import { Check, MessageCircle, X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Tooltip } from '@/components/ui/Tooltip';

type PatientWhatsAppStatusIconProps = {
	enabled: boolean;
	className?: string;
	size?: 'sm' | 'md';
};

const PatientWhatsAppStatusIcon = ({
	enabled,
	className,
	size = 'sm',
}: PatientWhatsAppStatusIconProps) => {
	const iconSize = size === 'md' ? 15 : 13;
	const badgeSize = size === 'md' ? 9 : 8;

	return (
		<Tooltip
			content={
				enabled
					? 'Notificações WhatsApp ativas'
					: 'Notificações WhatsApp desativadas'
			}
			position="top"
		>
			<span
				className={cn('relative inline-flex shrink-0', className)}
				aria-hidden
			>
				<MessageCircle
					size={iconSize}
					strokeWidth={2.25}
					className={enabled ? 'text-emerald-600' : 'text-zinc-900'}
				/>
				<span
					className={cn(
						'absolute -bottom-0.5 -right-0.5 flex items-center justify-center rounded-full bg-white',
						enabled ? 'text-emerald-600' : 'text-zinc-900',
					)}
				>
					{enabled ? (
						<Check size={badgeSize} strokeWidth={3} />
					) : (
						<X size={badgeSize} strokeWidth={3} />
					)}
				</span>
			</span>
		</Tooltip>
	);
};

export { PatientWhatsAppStatusIcon };
